import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { toArray } from "./toArray.js";
export const firstAsync = async (source, predicate) => {
    const data = await toArray(source);
    for (const value of data) {
        if (await predicate(value) === true) {
            return value;
        }
    }
    throw new InvalidOperationException(ErrorString.NoMatch);
};
